import { AVAILABLE_LANGUAGES, selectUserNotificationsEnabled, updateNotification } from 'containers/Login/loginSlice'
import { selectConfigContact, selectTheme, updateTheme } from 'appSlice'
import { selectIsLoggedIn } from 'containers/Login/loginSlice'
import { useDispatch, useSelector } from 'react-redux'
import FCMContext from 'context/firebase/Context'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import Switch from 'components/inputs/Switch'
import * as nativeApp from 'utils/nativeApp'
import useLanguage from 'hooks/useLanguage'
import { isDay } from 'utils/sunPosition'
import UserSettings from './UserSettings'
import { useReduxSelector } from 'store'
import { useContext } from 'react'
import Item from '../Item'

const isNativeApp = nativeApp.checkIsNativeApp()

const Settings = () => {
  const theme = useSelector(selectTheme)
  const isLoggedIn = useSelector(selectIsLoggedIn)
  const contact = useReduxSelector(selectConfigContact)
  const notificationsEnabled = useSelector(selectUserNotificationsEnabled)
  const { t, lang } = useTranslation('account')

  const dispatch = useDispatch()
  const updateLanguage = useLanguage()
  const { openPopup } = usePopupState()
  const { registerFCM, unregisterFCM } = useContext(FCMContext)

  return (
    <div className='account__settings'>
      <div className='account__header title'>
        <div>{t('settings')}</div>
        <div>{t('subTitle')}</div>
      </div>

      <p>{t('preferences')}</p>
      <div className='account__list'>
        <Item
          icon='brightness'
          title={t('themeAdaptedToTheTimeOfTheDay')}
          desc={t(theme.mode !== 'auto' ? 'off' : 'on')}
          right={<Switch
            name='theme-mode'
            checked={theme.mode === 'auto'}
            changeHandler={() => {
              if (theme.mode === 'auto') {
                const newMode = theme.light ? 'light' : 'dark'
                dispatch(updateTheme(newMode))
                nativeApp.changeTheme(newMode)
              } else {
                dispatch(updateTheme({ mode: 'auto', lightTheme: isDay() }))
                nativeApp.changeTheme('auto')
              }
            }}
          />}
        />

        <Item
          icon='moon'
          title={t('darkTheme')}
          disabled={theme.mode === 'auto'}
          desc={t(theme.light ? 'off' : 'on')}
          right={<Switch
            name='theme'
            checked={!theme.light}
            changeHandler={() => {
              const newTheme = theme.light ? 'dark' : 'light'
              dispatch(updateTheme(newTheme))
              nativeApp.changeTheme(newTheme)
            }}
          />}
        />

        {(isNativeApp || ('serviceWorker' in navigator && process.env.REACT_APP_VAPID_KEY)) && <Item
          icon='notifications'
          title={t('notifications')}
          desc={t(notificationsEnabled ? 'on' : 'off')}
          right={<Switch
            name='notifications'
            checked={notificationsEnabled}
            disabled={typeof notificationsEnabled !== 'boolean'}
            changeHandler={() => {
              if (typeof notificationsEnabled !== 'boolean') return
              if (notificationsEnabled) {
                if (isNativeApp) {
                  nativeApp.unregisterPushNotifications(true)
                  dispatch(updateNotification(undefined))
                } else {
                  unregisterFCM()
                }

              } else {
                if (isNativeApp) {
                  nativeApp.registerPushNotifications(true)
                  dispatch(updateNotification(undefined))
                } else {
                  registerFCM()
                }
              }
            }}
          />}
        />}

        <Item
          icon='translate'
          title={t('language')}
          desc={lang === AVAILABLE_LANGUAGES.pl ? 'polski' : 'english'}
          right={<Switch
            name='language'
            checked={lang === AVAILABLE_LANGUAGES.pl}
            changeHandler={() => {
              updateLanguage(lang === AVAILABLE_LANGUAGES.pl ? AVAILABLE_LANGUAGES.en : AVAILABLE_LANGUAGES.pl)
            }}
          />}
        />
      </div>

      {isLoggedIn && <UserSettings />}

      <p>{t('legal')}</p>
      <div className='account__list'>
        <Item
          showArrow
          icon='document'
          title={t('privacy')}
          action={() => {
            openPopup({ type: 'privacy' })
          }}
        />

        <Item
          showArrow
          icon='document'
          title={t('terms')}
          action={() => {
            openPopup({ type: 'terms' })
          }}
        />

        <Item
          showArrow
          icon='document'
          title={t('licenses')}
          action={() => {
            openPopup({ type: 'licenses' })
          }}
        />
      </div>

      <p>{t('aboutUs')}</p>
      {contact && <div className='settings__contact'>
        <div>{contact.companyName}</div>
        <div>NIP: {contact.companyNip}</div>
        <div>KRS: {contact.companyKrs}</div>
        <div>REGON: {contact.companyRegon}</div>
        <div>{contact.companyAddress}</div>
      </div>}
    </div>
  )
}

export default Settings